import { t } from 'i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import styles from './HomePageActions.module.scss';

interface HomePageActionsProps {
  isActivePageDefault: boolean;
  isEditMode: boolean;
  isViewOnly: boolean;
  onCustomize: () => void;
  onAddWidget: () => void;
  onCancel: () => void;
  onSave: () => void;
  onOpenApplyTemplateModal: () => void;
  onNavigateToWidgetTemplates: () => void;
  isSaving?: boolean;
}

export default function HomePageActions({
  isActivePageDefault,
  isEditMode,
  isViewOnly,
  onCustomize,
  onAddWidget,
  onCancel,
  onSave,
  onOpenApplyTemplateModal,
  onNavigateToWidgetTemplates,
  isSaving,
}: HomePageActionsProps) {
  if (isViewOnly && isActivePageDefault) {
    return null;
  }

  if (isEditMode) {
    return (
      <div className={styles.homePageActions}>
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          onClick={onCancel}
          disabled={isSaving}
          leftIcon="close"
        />
        {!isActivePageDefault && (
          <Button
            buttonText={t('home.apply-general-template')}
            buttonType={ButtonTypes.secondaryOutlined}
            onClick={onOpenApplyTemplateModal}
            disabled={isSaving}
          />
        )}
        <Button
          buttonText={t('add-widget')}
          buttonType={ButtonTypes.secondaryOutlined}
          data-test-id="home__add-widget-button"
          onClick={onAddWidget}
          disabled={isSaving}
          leftIcon="add"
        />
        <Button
          buttonText={t('save-view')}
          buttonType={ButtonTypes.primaryFilled}
          data-test-id="home__publish-button"
          onClick={onSave}
          disabled={isSaving}
          leftIcon="check"
        />
      </div>
    );
  }

  if (isViewOnly) {
    return (
      <div className={styles.homePageActions}>
        <Button
          buttonText={t('home.customize-current-view')}
          buttonType={ButtonTypes.primaryFilled}
          data-test-id="home__customize-button"
          onClick={onCustomize}
        />
      </div>
    );
  }

  return (
    <div className={styles.homePageActions}>
      <Button
        buttonText={t('home.manage-widget-templates')}
        buttonType={ButtonTypes.primaryOutlined}
        onClick={onNavigateToWidgetTemplates}
      />
      <Button
        buttonText={t('home.customize-current-view')}
        buttonType={ButtonTypes.primaryFilled}
        onClick={onCustomize}
      />
    </div>
  );
}
